import * as React from 'react';
import type { ForgePagePanelCommonProps } from '@helpcenter/forge-ui-utils';
import { PORTAL_FOOTER_MODULE } from '@helpcenter/forge-ui-utils/src/constants';
import { di } from 'react-magnetic-di';
import { ForgeRunnerModule } from 'view/forge-ui/forge-runner';
import { ForgeRunnerContainer } from 'view/forge-ui/forge-runner/styled';

const ForgeFooterModule: React.FC<ForgePagePanelCommonProps> = ({
    page,
    portalId,
    projectId,
    requestKey,
    requestTypeId,
    noWrapper,
    allowCustomPadding,
}) => {
    di(ForgeRunnerModule);
    return (
        <ForgeRunnerContainer allowCustomPadding={allowCustomPadding}>
            <ForgeRunnerModule
                type={PORTAL_FOOTER_MODULE}
                page={page}
                projectId={projectId}
                portalId={portalId}
                requestKey={requestKey}
                requestTypeId={requestTypeId}
                noWrapper={noWrapper}
            />
        </ForgeRunnerContainer>
    );
};

export default ForgeFooterModule;
